import { render, staticRenderFns } from "./addLeave.vue?vue&type=template&id=4589e23e&"
import script from "./addLeave.vue?vue&type=script&lang=js&"
export * from "./addLeave.vue?vue&type=script&lang=js&"
import style0 from "./addLeave.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports